import en from '../../../components/i18nProvider/en';
import { Iprefix } from '../../../hooks/useTranslation';

const translatePrefix: Iprefix = 'distributorAgentWallet';

export const getTabTranslatePrefix = (tab: keyof (typeof en)['distributorAgentWallet']) =>
  (translatePrefix + '.' + tab) as Iprefix;
